// extracted by mini-css-extract-plugin
export default {"table_panel":"ParameterPanel_table_panel__aGOQW"};